import type { FC } from "react";
import styled, { css } from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { EPrimaryItemType, SubsectionItem } from "@similarweb/ui-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

interface IEducationElement {
    isBarOpen: boolean;
    link: string;
}

const { blue, carbon } = colorsPalettes;

const badgeStyle = () => {
    return css`
        background: ${blue[400]} !important;
        ${mixins.setFontVariant("tag", colorsPalettes.carbon["0"])};
        padding: 4px 5px;
        height: 8px;
        border-radius: 16px;
        position: absolute;
        align-items: center;
        justify-content: space-around;
        top: 7px;
        left: 175px;
        animation: none;
        display: flex;
    `;
};

const Container = styled.div<{ isCollapsed: boolean }>`
    position: relative;

    .beamer_icon.active {
        ${badgeStyle}
        ${({ isCollapsed }) => isCollapsed && `display:none;`}
    }
`;

const EDUCATION_ELEMENT_ID = "education-element";

export const EducationElement: FC<IEducationElement> = ({ isBarOpen, link }) => {
    const translate = useTranslation();
    const onClick = () => {
        window.open(link, "_blank");
    };
    return (
        <Container
            id={EDUCATION_ELEMENT_ID}
            isCollapsed={!isBarOpen}
        >
            <SubsectionItem
                key={EDUCATION_ELEMENT_ID}
                itemText={translate("education.element.title")}
                icon={"sidebar3-updates-news"}
                itemType={EPrimaryItemType.SecondaryAction}
                isCollapsed={!isBarOpen}
                onItemClick={onClick}
            />
        </Container>
    );
};
